import React from "react";
import AdministrationSummary from "../../features/administrationsummary";

const ApplicationsSummaryPage = () => <AdministrationSummary />

export default ApplicationsSummaryPage;